import vuetifyDefaultLang from 'vuetify/src/locale/en.ts';

export default {
  $vuetify: {
    ...vuetifyDefaultLang,
  },
};
